<template>
  <div class="spider-status-history">
    <v-dialog v-model="dialog" max-width="600" @input="close">
      <v-card>
        <v-card-title>
          История изменений статуса
          <div class="spacer"></div>
          <div>
            <v-icon class="white--text" @click="close">close</v-icon>
          </div>
        </v-card-title>
        <v-card-text>
          <v-data-table
            item-key="id"
            class="spider-status-history__table my-4"
            :headers="headers"
            :items="items"
            :disable-pagination="true"
            :hide-default-footer="true"
            dense
          >
            <template v-slot:item.created="{ item }">
              {{ $moment(item.created).format() }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    dialog: false,
    headers: [
      {
        text: 'Дата',
        value: 'created',
      },
      {
        text: 'Пользователь',
        value: 'username',
      },
      {
        text: 'Статус',
        value: 'status_name',
      },
    ],
  }),
  watch: {
    show(newVal) {
      this.dialog = newVal
    },
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    },
  },
})
</script>
<style scoped></style>
